import { Theme, styled } from '@material-ui/core';

const CardContent = styled('div')<Theme>(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(0, 3),
  boxSizing: 'border-box',
}));

export default CardContent;
